export const handleAutofocus =
  (shouldAutofocus: boolean, dirty: boolean) =>
  (inputRef: React.Ref<any> & { focus?: () => void }) => {
    if (!inputRef || !inputRef.focus || !shouldAutofocus || dirty) {
      return;
    }

    inputRef.focus();
  };
